<template>
  <div v-if="mapLocation && point && point.data">
    <div 
      :key="pointId" 
      :style="markerStyle"
      @click="handleClick"
    >
      <div>
        <div v-if="!point.data.icon" class="mapLabel">
          {{ point.data.order }}
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    {{ point.data.order }} has no map location
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'VueMapMarker',
  props: {
    pointId: {
      type: String,
      required: true
    },
    point: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    
    // Calculate map location based on map_location (x,y coordinates)
    mapLocation() {
      if (!this.point?.data?.map_location) {
        return null
      }
      
      let top = 0
      let left = 0
      
      // Parse map_location which contains comma-separated top,left values
      const data = this.point.data.map_location.split(',')
      if (data.length === 2) {
        top = parseFloat(data[0])
        left = parseFloat(data[1])
      }
      
      // Check if coordinates are valid (both > 0)
      if (top > 0 && left > 0) {
        return { top, left }
      }
      
      return null
    },
    
    // Get point icon
    pointIcon() {
      return this.point?.data?.icon?.preview_url || null
    },
    
    // Marker style object
    markerStyle() {
      if (!this.mapLocation) {
        return {}
      }
      
      return {
        position: 'absolute',
        left: this.mapLocation.left + '%',
        top: this.mapLocation.top + '%',
        width: '24px',
        height: '24px',
        margin: '-24px -12px 0',
        backgroundImage: this.pointIcon 
          ? `url('${this.pointIcon}')` 
          : "url('/static/markers/default.svg')",
        backgroundSize: '24px',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        cursor: 'pointer'
      }
    }
  },
  methods: {
    handleClick() {
      if (this.point?.data) {
        // Pass the data in the format expected by handleItemClick
        // React expects: { point: { id: ... }, data: ... }
        const pointData = {
          point: { id: this.point.data.point?.id || this.pointId },
          data: this.point.data
        }
        this.onClick(pointData, false)
      }
    }
  }
}
</script>

